import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export default function ConversationDetail() {
  const { id } = useParams();

  const { data: messages, isLoading } = useQuery({
    queryKey: ['admin-conversation-detail', id],
    queryFn: async () => {
      if (!id) return [];
      const { data } = await supabase
        .from('chat_messages')
        .select('id, role, content, created_at, timing_metadata')
        .eq('session_id', id)
        .order('created_at', { ascending: true })
        .limit(500);
      return data || [];
    },
    enabled: !!id,
  });

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Conversation</h1>
          <p className="text-muted-foreground">Session ID: <span className="font-mono text-xs">{id}</span></p>
        </div>
        <div className="border rounded-lg overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Role</TableHead>
                <TableHead>Message</TableHead>
                <TableHead>Latency</TableHead>
                <TableHead>Created</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {(messages || []).map((m: any) => (
                <TableRow key={m.id}>
                  <TableCell className="capitalize">{m.role}</TableCell>
                  <TableCell className="text-sm max-w-[600px] truncate" title={m.content}>{m.content}</TableCell>
                  <TableCell className="text-xs">{m?.timing_metadata?.total_latency_ms ? `${m.timing_metadata.total_latency_ms} ms` : '—'}</TableCell>
                  <TableCell>{new Date(m.created_at).toLocaleString()}</TableCell>
                </TableRow>
              ))}
              {(!isLoading && (messages || []).length === 0) && (
                <TableRow>
                  <TableCell colSpan={4} className="text-center text-muted-foreground">No messages</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}


